<template>
	<div class="zhaopin">
		<div class="zhaopin-top">
			<img src="../../static/img/zhaopin.png"/>
			<div class="com-tit">
				<span>
					<img src="../../static/img/zhaopinicon.png"/><b>诚聘英才</b>
				</span>
				<p>别藏了，就是你！寻找与众不同的你，思程等你来点新花样！<br />
高薪诚聘，我们等待您的加入！</p>
			</div>
		</div>
		<div class="zhaopin-choose">
			<div class="choose-top">
				<div class="top-sel" v-for="sel in choose" @click="selclick(sel.id)">
					<img :src="sel.imgsrc" v-if="selid != sel.id"/>
					<img :src="sel.imgsrcl" v-if="selid == sel.id"/>
					<p v-bind:class="{activep : selid == sel.id}">{{sel.name}}</p>
				</div>
			</div>
			<div class="choose-center">
				<transition name="zhaopin-fade">
					<div class="center-detail" >
						<ul v-for="cen in zhiwei" v-show="conid == cen.department"> 
							<li v-bind:class="{liactivecon : cen.id == liid}" @click="liclick(cen.id)" > 
								<div class="center-line"></div>
								<b>{{cen.type}}</b>
								<span class="det-sta">
									职位 ： {{cen.position}}  &nbsp;&nbsp;&nbsp;&nbsp; 薪资 ： {{cen.money}}  &nbsp;&nbsp;&nbsp;&nbsp; 招聘状态 ： {{cen.status}} &nbsp;&nbsp;&nbsp;&nbsp; 招聘人数 ： {{cen.persons}}
								</span>
								<span class="right glyphicon" v-bind:class="{'glyphicon-triangle-bottom' : cen.id == liid}"></span>
								<span class="right glyphicon" v-bind:class="{'glyphicon-triangle-right' : cen.id != liid}"></span>
							</li>
							<transition name="zhaopin-fade">
								<div class="det-content" v-show="cen.id == liid">
									<div v-html="cen.demand">
										{{cen.demand}}
									</div>
									
								</div>
							</transition>
						</ul>
					</div>
				</transition>
			</div>
		</div>
	</div>
	
</template>

<script>
	export default{
		name : 'zhaopin',
		data(){
			return{
				img: [//配置图片，循环使用
					{id : 0 , imgsrc : 'static/img/zhaopin-z.png' , imgsrcl : 'static/img/zhaopin-zl.png'},
					{id : 1 , imgsrc : 'static/img/zhaopin-c.png' , imgsrcl : 'static/img/zhaopin-cl.png'},
					{id : 2 , imgsrc : 'static/img/zhaopin-x.png' , imgsrcl : 'static/img/zhaopin-xl.png'},
					{id : 3 , imgsrc : 'static/img/zhaopin-y.png' , imgsrcl : 'static/img/zhaopin-yl.png'},
				],
				choose :[
				// {id : 0 , imgsrc : 'static/img/zhaopin-z.png' , imgsrcl : 'static/img/zhaopin-zl.png' , name : '总经办'},
				// {id : 1 , imgsrc : 'static/img/zhaopin-c.png' , imgsrcl : 'static/img/zhaopin-cl.png' , name : '产品部'},
				// {id : 2 , imgsrc : 'static/img/zhaopin-x.png' , imgsrcl : 'static/img/zhaopin-xl.png' , name : '业务部'},
				// {id : 3 , imgsrc : 'static/img/zhaopin-y.png' , imgsrcl : 'static/img/zhaopin-yl.png' , name : '项目部'},
				// {id : 4 , imgsrc : 'static/img/zhaopin-z.png' , imgsrcl : 'static/img/zhaopin-zl.png' , name : '测试部门1'},
				// {id : 5 , imgsrc : 'static/img/zhaopin-c.png' , imgsrcl : 'static/img/zhaopin-cl.png' , name : '测试部门2'},
				// {id : 6 , imgsrc : 'static/img/zhaopin-x.png' , imgsrcl : 'static/img/zhaopin-xl.png' , name : '测试部门3'},
				// {id : 7 , imgsrc : 'static/img/zhaopin-y.png' , imgsrcl : 'static/img/zhaopin-yl.png' , name : '测试部门4'},
				],
				selid : 0,			//选中的部门id
				conid : '',			//选中的部门名称
				liid : 0,			//当前展开的li序号，0为全部关闭
				zhiwei :[],			//获取的招聘数据
			}
		},
		mounted(){
				this.getzhaopin();
		},
		watch:{
		  	selid : function(){
		  		this.liid = 0
		  		//this.getzhaopin()
		  	}
		},
		metaInfo: {
			title: '诚聘英才'
		},
		methods :{
			getzhaopin(){
				var that =this;
				this.$http.post('http://gd-sc.net:9092/api/GDSC_Job/getjob').then((response) => {
				//this.$http.post('http://localhost:9090/api/GDSC_Job/getjob').then((response) => {
					//console.log(response.body)
					this.zhiwei = response.body;
					//获取数据
					var pData = response.body
					var pLength = pData.length
					//获取部门并去掉重复
					var department = {}
					var depArr = []
					for(var i=0; i<pLength; i++){
						department[pData[i].department] = pData[i].department
					}
					for(var key in department) {
						depArr.push(key)
					}
					//生成choose
					var choose = []
					for(var i=0; i<depArr.length; i++) {
						var item = {}
						item.id = i
						item.imgsrc = this.img[i%this.img.length].imgsrc
						item.imgsrcl = this.img[i%this.img.length].imgsrcl
						item.name = depArr[i]
						choose.push(item)
					}
					this.choose=choose
					//console.log(choose)

					//初始化截取前10位时间数据
					this.conid = this.choose[0].name
			        for(var i=0 ; i<response.body.length ; i++){
			        	var data =  response.body[i].createDate;
						response.body[i].createDate = data.substr(0,10)
					}
			    })
			},
			selclick(id){
				//点击选项后
				this.selid = id
				this.conid = this.choose[id].name
			},
			liclick(id){
				//console.log(id)
				if(id != this.liid) {
					this.liid = id
				}else {
					this.liid = 0
				}
				
			}
		},
	}
</script>

<style>
	.zhaopin{
		width: 100%;
		position: relative;
		clear: both;
	}
	.zhaopin-top{
		position: relative;
		clear: both;
		width: 100%;
		margin: 0 auto;
	}
	.zhaopin-top img {
		width: 100%;
	}
	.zhaopin-choose{
		position: relative;
		clear: both;
		width: 80%;
		padding: 60px 0;
		margin: 0 auto;
	}
	.choose-top{
		position: relative;
		width: 70%;
		clear: both;
		margin: 0 auto 50px;
	}
	.top-sel{
		position: relative;
		width: 20%;
		display: inline-block;
		clear: both;
	}
			.com-tit{
		width: 40%;
		position: absolute;
		clear: both;
		z-index: 3;
		top: 12vw;
	    left: 11vw;
	    text-align: left;
	    font-size: 22px;
	    color: #fff;
	}
	.com-tit img {
	    width: 4% !important;
	    margin-right: 23px;
	}
	.com-tit p{
		margin-top: 20px;
		font-size: 14px;
		line-height: 28px;
	}
	.com-tit b{
		font-size: 25px;
	    position: relative;
	    top: 3px;
	}
	.top-sel img{
		width: 50%;
		position: relative;
	}
	.choose-center{
		position: relative;
		width: 100%;
	}
	.choose-top p{
		margin-top: 30px;
		font-size: 17px;
	}
	.choose-top p.activep{
		color: #0066ef;
	}
	.choose-center li{
		padding: 15px 0;
		text-align: left;
		list-style: none;
		position: relative;
		border-bottom: 1px solid #d7d7d7;
	}
	.choose-center li.liactivecon{
		background: #f1f1f1;
		border-top: 3px solid #d7d7d7;
	}
	.choose-center li b{
		font-size: 16px;
		position: relative;
		left: 40px;
		padding: 0 20px;
		display: inline-block;
	}
	.center-line{
		background: #0066ef;
		width: 20px;
		height: 3px;
		position: absolute;
		top: 23px;
		left: 20px;
	}
	.choose-center span.det-sta{
		display: inline-block;
		margin-left: 50px;
	}
	.choose-center span.glyphicon-triangle-bottom{
		color: #666666 !important;
	}
	.choose-center span.glyphicon{
		position: absolute;
		top: 18px;
		right: 20px;
		color: #bbbbbb;
	}
	.det-content{
		position: relative;
		clear: both;
		text-align: left;
		margin: 40px 20px;
	}
	.det-content p{
		line-height: 20px;
		margin: 30px 0;
		color: #555555;
	}
	.zhaopin-fade-enter-active {
	  transition: all .3s ease;
	}
	.zhaopin-fade-leave-active {
	  transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}
	.zhaopin-fade-enter, .zhaopin-fade-leave-to
	/* .slide-fade-leave-active for below version 2.1.8 */ {
	  transform: translateY(30px);
	  opacity: 0;
	}
	.center-detail{
		position: relative;
	}
</style>


// WEBPACK FOOTER //
// src/components/zhaopin.vue